import { NavLink } from 'react-router-dom'
import { useApprovalsPendingCount } from '@/hooks/use-approvals'
import { useAuth } from '@/hooks/use-auth'
import { cn } from '@/lib/utils'
import { sidebarNavByRole, type NavRole } from './nav-config'

const APPROVALS_PATHS = new Set(['/committee/approvals', '/admin/approvals'])

export function Sidebar({ role, portalLabel }: { role: NavRole; portalLabel: string }) {
  const { user } = useAuth()
  const featureAccess = user?.featureAccess
  const nav = sidebarNavByRole[role].filter(
    (item) => !item.feature || featureAccess?.[item.feature] !== false,
  )
  const isApprover = role === 'committee' || role === 'admin'
  const pendingCount = useApprovalsPendingCount(isApprover)

  return (
    <aside className="hidden w-sidebar shrink-0 flex-col bg-navy lg:flex">
      <div className="border-b border-cream/10 px-6 py-5">
        <p className="font-serif text-xl font-medium tracking-[0.06em] text-cream uppercase">
          Riverpark
        </p>
        <p className="mt-1 font-sans text-[10px] font-medium uppercase tracking-[0.12em] text-cream/40">
          {portalLabel}
        </p>
        <div className="mt-3 h-0.5 w-12 bg-green-lt" aria-hidden />
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 py-4">
        {nav.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded px-3 py-2.5 font-sans text-sm font-medium transition-colors duration-150',
                isActive
                  ? 'border-l-[3px] border-green-lt bg-cream/10 pl-[9px] text-cream/95'
                  : 'border-l-[3px] border-transparent text-cream/50 hover:bg-cream/5 hover:text-cream/80',
              )
            }
          >
            <Icon size={18} strokeWidth={1.75} aria-hidden />
            {label}
            {APPROVALS_PATHS.has(to) && pendingCount > 0 && (
              <span className="ml-auto flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1.5 font-sans text-[11px] font-semibold text-white">
                {pendingCount}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-cream/10 px-6 py-4">
        <p className="font-sans text-xs text-cream/25">Riverpark Estate · Ruiru</p>
      </div>
    </aside>
  )
}
